import { HalResource } from '../hal/models/HalResource';
import { EmbeddedCollection } from './EmbeddedCollection';
export var SearchesOrderBy;
(function (SearchesOrderBy) {
    SearchesOrderBy["SEARCH_COUNT"] = "searchCount";
    SearchesOrderBy["CLICK_THROUGH_RATE"] = "clickThroughRate";
    SearchesOrderBy["CONVERSION_RATE"] = "conversionRate";
    SearchesOrderBy["AVERAGE_CLICK_POSITION"] = "averageClickPosition";
})(SearchesOrderBy || (SearchesOrderBy = {}));
/**
 * Class representing search analytics for an Algolia Search Index
 */
export class SearchIndexTopSearches extends HalResource {
}
/**
 * @hidden
 */
export class SearchIndexTopSearchesCollection extends EmbeddedCollection {
    constructor(data) {
        super('top-searches', SearchIndexTopSearches, data);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VhcmNoSW5kZXhUb3BTZWFyY2hlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWwvU2VhcmNoSW5kZXhUb3BTZWFyY2hlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFDeEQsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFFMUQsTUFBTSxDQUFOLElBQVksZUFLWDtBQUxELFdBQVksZUFBZTtJQUN6QiwrQ0FBNEIsQ0FBQTtJQUM1QiwwREFBdUMsQ0FBQTtJQUN2QyxxREFBa0MsQ0FBQTtJQUNsQyxrRUFBK0MsQ0FBQTtBQUNqRCxDQUFDLEVBTFcsZUFBZSxLQUFmLGVBQWUsUUFLMUI7QUFFRDs7R0FFRztBQUNILE1BQU0sT0FBTyxzQkFBdUIsU0FBUSxXQUFXO0NBNkN0RDtBQUVEOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGdDQUFpQyxTQUFRLGtCQUVyRDtJQUNDLFlBQVksSUFBVTtRQUNwQixLQUFLLENBQUMsY0FBYyxFQUFFLHNCQUFzQixFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ3RELENBQUM7Q0FDRiJ9